import { SharedAppConstants } from '@tock/shared-app-constants';
import { core, toJSONArray } from '@tock/coretypes';

interface State {
  accoladeTypes: core.AccoladeType[];
  requestInProgress: boolean;
}

const initialState: State = {
  accoladeTypes: [],
  requestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.ACCOLADE_TYPE_INSERT_STARTING:
    case SharedAppConstants.ACCOLADE_TYPE_FETCH_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case SharedAppConstants.ACCOLADE_TYPE_INSERT_FAILED:
    case SharedAppConstants.ACCOLADE_TYPE_FETCH_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case SharedAppConstants.ACCOLADE_TYPE_INSERT_DONE: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case SharedAppConstants.ACCOLADE_TYPE_FETCH_DONE: {
      return {
        ...state,
        requestInProgress: false,
        accoladeTypes: toJSONArray<core.AccoladeType>(payload),
      };
    }
    default:
      return state;
  }
}
